import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink, FiCalendar, FiUser } from 'react-icons/fi';
import Badge from '../UI/Badge';
import './CertificateCard.css';

const CertificateCard = ({ certificate, size = "large" }) => {
  const {
    title,
    institution,
    category,
    year,
    icon,
    color,
    description,
    skills,
    link,
    status
  } = certificate;

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  const handleCertificateView = () => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <motion.div
      className={`certificate-card ${size === 'small' ? 'certificate-card--small' : ''}`}
      variants={cardVariants}
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
    >
      <div className="certificate-card__header">
        <div className="certificate-card__icon" style={{ color }}>
          {icon}
        </div>
        <Badge 
          variant={status === 'completed' ? 'success' : 'warning'}
          size="small"
          className="certificate-card__status"
        >
          {status === 'completed' ? 'Concluído' : 'Em andamento'}
        </Badge>
      </div>

      <div className="certificate-card__content">
        <div className="certificate-card__category">
          <Badge variant="outline" size="small">
            {category}
          </Badge>
        </div>

        <h3 className="certificate-card__title">{title}</h3>

        <div className="certificate-card__institution">
          {institution}
        </div>

        <div className="certificate-card__year">
          {year}
        </div>

        <div className="certificate-card__skills">
          {skills.slice(0, 3).map((skill, index) => (
            <Badge key={index} variant="default" size="small">
              {skill}
            </Badge>
          ))}
          {skills.length > 3 && (
            <Badge variant="primary" size="small">
              +{skills.length - 3} mais
            </Badge>
          )}
        </div>
      </div>

      <div className="certificate-card__footer">
        <button
          className="certificate-card__link"
          onClick={handleCertificateView}
          disabled={!link || link === '#'}

          title={!link || link === '#' ? 'Link não disponível' : 'Ver certificado'}
        >
          <FiExternalLink />
          <span>Ver Certificado</span>
        </button>
      </div>
    </motion.div>
  );
};

export default CertificateCard;